export default __webpack_public_path__ + "static/media/aar-file-export.6f4feb6f.svg";